import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { entryIsInMyList } from "../Utils/Entry";
import { PreparedEntry } from "../Utils/Entry";

const myListSlice = createSlice({
    name: 'MyList',
    initialState: {
        entries: null as PreparedEntry[]|null,
    },
    reducers: {
        setEntries(state, action: PayloadAction<{ entries: PreparedEntry[] }>) {
            state.entries = action.payload.entries
        },
        mergeEntry(state, action: PayloadAction<Partial<PreparedEntry> & Pick<PreparedEntry, "id">>) {
            if(!action.payload?.id) {
                throw Error("'id' must be provided to mergeEntry reducer");
            }
            state.entries = state.entries?.map(entry => {
                if(entry.id === action.payload.id) {
                    return {
                        ...entry,
                        ...action.payload,
                    }
                }
                return entry;
            }) ?? null;
        },
        addMergeOrRemoveEntry(state, action: PayloadAction<PreparedEntry>) {
            if(!action.payload?.id) {
                throw Error("'id' must be provided to addMergeOrRemoveEntry reducer");
            }

            const newEntry = action.payload;
            const currentMyList = state.entries ?? [];

            const newMyList = (newEntry.isInMyList && !(currentMyList.find(entry => entry.id === newEntry.id)))
                // if true then we are adding to the list
                ? [...currentMyList, newEntry]
                // in all other cases we find the entry in the list and update it, then filter out any that are being removed
                : currentMyList
                    // update the entry
                    .map(oldEntry => {
                        if(newEntry.id === oldEntry.id) {
                            return {
                                ...oldEntry,
                                ...newEntry,
                            }
                        }
                        return oldEntry;
                    })
                    // remove from my list if it isn't in there
                    .filter(entry => entryIsInMyList(entry));
            
            state.entries = newMyList;
        }
    }
});

export const myListActions = myListSlice.actions;
export default myListSlice.reducer;